import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useHistory } from 'react-router-dom';
import API_BASE_URL from '../config';
import './GuestVendors.css';

interface Vendor {
    _id: string;
    name: string;
    category: string;
    contactNumber: string;
}

const GuestVendors: React.FC = () => {
    const { accessToken } = useAuth();
    const history = useHistory();
    const [vendors, setVendors] = useState<Vendor[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchVendors = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/vendors`, {
                    headers: { Authorization: `Bearer ${accessToken}` }
                });
                const data = await response.json();
                if (response.ok) {
                    setVendors(data.vendors);
                }
            } catch (err) {
                console.error('Error fetching vendors');
            } finally {
                setLoading(false);
            }
        };

        if (accessToken) fetchVendors();
    }, [accessToken]);

    // Group vendors by category
    const groupedVendors = vendors.reduce((acc, vendor) => {
        if (!acc[vendor.category]) acc[vendor.category] = [];
        acc[vendor.category].push(vendor);
        return acc;
    }, {} as Record<string, Vendor[]>);

    if (loading) return <div className="guest-vendors-page">Loading...</div>;

    return (
        <div className="guest-vendors-page">
            <header className="vendors-header">
                <button className="back-btn" onClick={() => history.goBack()}>←</button>
                <div className="header-text">
                    <h1>Wedding Partners</h1>
                    <p>Contact info for our amazing service providers</p>
                </div>
            </header>

            <main className="vendors-main">
                {vendors.length === 0 ? (
                    <div className="empty-state">
                        <span className="empty-icon">🏪</span>
                        <h3>No vendors listed yet</h3>
                        <p>Keep checking back for contact information of our wedding services.</p>
                    </div>
                ) : (
                    Object.entries(groupedVendors).map(([category, categoryVendors]) => (
                        <section key={category} className="category-section">
                            <h2 className="category-title">{category}</h2>
                            <div className="guest-vendor-grid">
                                {categoryVendors.map((vendor) => (
                                    <div key={vendor._id} className="guest-vendor-card glass-panel">
                                        <div className="vendor-main">
                                            <h3>{vendor.name}</h3>
                                            <a href={`tel:${vendor.contactNumber}`} className="call-btn">
                                                📞 {vendor.contactNumber}
                                            </a>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>
                    ))
                )}
            </main>
        </div>
    );
};

export default GuestVendors;

